import { render, staticRenderFns } from "./PurchaseOrderSch.vue?vue&type=template&id=1fc71cfb&scoped=true&"
import script from "./PurchaseOrderSch.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderSch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc71cfb",
  null
  
)

export default component.exports